<app-button
    [type]="type"
    [color]="color"
    [icon]="icon"
    [iconPos]="iconPos"
    [buttonText]="buttonText"
    [disabled]="disabled"
    [isLoading]="isLoading"
    [highlight]="highlight"
    [tooltip]="tooltip"
    (buttonClick)="buttonClick()"
></app-button>
